import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  obtManagementInfoId: 0,
  parentClientDesc: "",
  clientDesc: "",
  programDesc: "",
  projectDesc: "",
  projectCodeFull: "",
  bsTask: "",
  idmSupport: "",
  ogSupported: false,
  idmDeploymentStatus: "",
  rampDownDate: "",
  rosterLockBusDays: 0,
  rosterLockFrom: "",
  ttecAccessSLABusDays: 0,
  clientAccessSLABusDays: 0,
  clientAccessRequestType: "",
  primaryIDMPOC: "",
  backupIDMPOC: "",
  clientDistro: null,
  clientOffboarding: false,
  idmTeamLead: "",
  idmTeamEmail: "",
  primaryOGs: "",
  backupOGs: "",
  idmOwner: "",
  idmEscalationPoint: "",
  switchIDPOC: "",
  ogOwner: "",
  ogEscalationPoint: "",
  ogTeamEmail: "",
  contactNumber: false,
  gender: false,
  nationalIdentifier: false,
  dateOfBirth: false,
  country: false,
  recruiter: false,
  token: false,
  confirmPreviousEmploymentWithClient: false,
  nickname: false,
  licenseNPN: false,
  productTrainingDate: false,
  address: false,
  city: false,
  state: false,
  postalCode: false,
  availability: false,
  inboundOutbound: false,
  language: false,
  integrationDate: false,
  email: false,
  nestingDate: false,
  productionDate: false,
  backgroundStatusDate: false,
  personalEmail: false,
  modifiedBy: null,

  primaryTAOracleId: null,
  backupTAOracleId: null,
  taTeamEmail: "",

  ldExecutiveOracleId: null,
  ldLevel1OracleId: null,
  ldLevel2OracleId: null,
  ldLevel3OracleId: null,
  ldLevel4OracleId: null,
  lpPortfolioId: 4, // Default to Healthcare (ID=4)
};

const obtInfoManagementSlice = createSlice({
  name: "obtInfoManagement",
  initialState,
  reducers: {
    setObtManagementInfoId(state, action) {
      state.obtManagementInfoId = action.payload;
    },
    setParentClientDesc(state, action) {
      state.parentClientDesc = action.payload;
    },
    setClientDesc(state, action) {
      state.clientDesc = action.payload;
    },
    setProgramDesc(state, action) {
      state.programDesc = action.payload;
    },
    setProjectDesc(state, action) {
      state.projectDesc = action.payload;
    },
    setProjectCodeFull(state, action) {
      state.projectCodeFull = action.payload;
    },
    setBsTask(state, action) {
      state.bsTask = action.payload;
    },
    setIdmSupport(state, action) {
      state.idmSupport = action.payload;
    },
    toggleOgSupported(state, action) {
      state.ogSupported = action.payload;
    },
    setIdmDeploymentStatus(state, action) {
      state.idmDeploymentStatus = action.payload;
    },
    setRampDownDate(state, action) {
      state.rampDownDate = action.payload;
    },
    setRosterLockBusDays(state, action) {
      state.rosterLockBusDays = action.payload;
    },
    setRosterLockFrom(state, action) {
      state.rosterLockFrom = action.payload;
    },
    setTtecAccessSLABusDays(state, action) {
      state.ttecAccessSLABusDays = action.payload;
    },
    setClientAccessSLABusDays(state, action) {
      state.clientAccessSLABusDays = action.payload;
    },
    setClientAccessRequestType(state, action) {
      state.clientAccessRequestType = action.payload;
    },
    setPrimaryIDMPOC(state, action) {
      state.primaryIDMPOC = action.payload;
    },
    setBackupIDMPOC(state, action) {
      state.backupIDMPOC = action.payload;
    },
    setClientDistro(state, action) {
      state.clientDistro = action.payload;
    },
    toggleClientOffboarding(state, action) {
      state.clientOffboarding = action.payload;
    },
    setIdmTeamLead(state, action) {
      state.idmTeamLead = action.payload;
    },
    setIdmTeamEmail(state, action) {
      state.idmTeamEmail = action.payload;
    },
    setPrimaryOGs(state, action) {
      state.primaryOGs = action.payload;
    },
    setBackupOGs(state, action) {
      state.backupOGs = action.payload;
    },
    setIdmOwner(state, action) {
      state.idmOwner = action.payload;
    },
    setOgOwner(state, action) {
      state.ogOwner = action.payload;
    },
    setOgTeamEmail(state, action) {
      state.ogTeamEmail = action.payload;
    },
    setIdmEscalationPoint(state, action) {
      state.idmEscalationPoint = action.payload;
    },
    setSwitchIDPOC(state, action) {
      state.switchIDPOC = action.payload;
    },
    setOgEscalationPoint(state, action) {
      state.ogEscalationPoint = action.payload;
    },
    setContactNumber(state, action) {
      state.contactNumber = action.payload;
    },
    setGender(state, action) {
      state.gender = action.payload;
    },
    setNationalIdentifier(state, action) {
      state.nationalIdentifier = action.payload;
    },
    setDateOfBirth(state, action) {
      state.dateOfBirth = action.payload;
    },
    setCountry(state, action) {
      state.country = action.payload;
    },
    setRecruiter(state, action) {
      state.recruiter = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    setConfirmPreviousEmploymentWithClient(state, action) {
      state.confirmPreviousEmploymentWithClient = action.payload;
    },
    setNickname(state, action) {
      state.nickname = action.payload;
    },
    setLicenseNPN(state, action) {
      state.licenseNPN = action.payload;
    },
    setProductTrainingDate(state, action) {
      state.productTrainingDate = action.payload;
    },
    setAddress(state, action) {
      state.address = action.payload;
    },
    setCity(state, action) {
      state.city = action.payload;
    },
    setState(state, action) {
      state.state = action.payload;
    },
    setPostalCode(state, action) {
      state.postalCode = action.payload;
    },
    setAvailability(state, action) {
      state.availability = action.payload;
    },
    setInboundOutbound(state, action) {
      state.inboundOutbound = action.payload;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setIntegrationDate(state, action) {
      state.integrationDate = action.payload;
    },
    setEmail(state, action) {
      state.email = action.payload;
    },
    setNestingDate(state, action) {
      state.nestingDate = action.payload;
    },
    setProductionDate(state, action) {
      state.productionDate = action.payload;
    },
    setBackgroundStatusDate(state, action) {
      state.backgroundStatusDate = action.payload;
    },
    setPersonalEmail(state, action) {
      state.personalEmail = action.payload;
    },
    setModifiedBy(state, action) {
      state.modifiedBy = action.payload;
    },

    setPrimaryTAOracleId(state, action) {
      state.primaryTAOracleId = action.payload;
    },
    setBackupTAOracleId(state, action) {
      state.backupTAOracleId = action.payload;
    },
    setTATeamEmail(state, action) {
      state.taTeamEmail = action.payload;
    },
    setLDExecutiveOracleId(state, action) {
      state.ldExecutiveOracleId = action.payload;
    },
    setLDLevel1OracleId(state, action) {
      state.ldLevel1OracleId = action.payload;
    },
    setLDLevel2OracleId(state, action) {
      state.ldLevel2OracleId = action.payload;
    },
    setLDLevel3OracleId(state, action) {
      state.ldLevel3OracleId = action.payload;
    },
    setLDLevel4OracleId(state, action) {
      state.ldLevel4OracleId = action.payload;
    },
    setLPPortfolioId(state, action) {
      state.lpPortfolioId = action.payload;
    },
    setAllValues(state, action) {
      return action.payload;
    },

    resetValues() {
      return initialState;
    },
  },
});

export const obtInfoManagementActions = obtInfoManagementSlice.actions;

export default obtInfoManagementSlice.reducer;
